import { RootState } from "@store/reducers";
import { diffBetweenTwoDays } from "@utils/commonUtils";
import { notification } from "antd";
import dayjs from "dayjs";
import { useSelector } from "react-redux";

const today = new Date();
const options = [
  { value: 'Yes', label: 'Yes' },
  { value: 'No', label: 'No' }
]

export const NewBornDetailsData:any = {
  babyCried: {
    '#type': 'select',
    '#title': 'Baby cried immediately at Birth?',
    '#webform_key': 'babyCried',
    '#options': [],
    '#required': true,
  },
  referred: {
    '#type': 'select',
    '#title': 'Referred to higher facility for further management',
    '#webform_key': 'referred',
    '#options': [],
    '#required': true,
    '#isDisabled': true
  },
  isChildAdmitted: {
    '#type': 'select',
    '#title': 'Is Child Admitted in NBSU/ SNCU/ NICU',
    '#webform_key': 'isChildAdmitted',
    '#options': [],
    '#required': true,
  },
  birthDefectSeen: {
    '#type': 'select',
    '#title': 'Any visible birth defect seen?',
    '#webform_key': 'birthDefectSeen',
    '#options': [],
    '#required': true,
  },
  ifDefectIdentified: {
    '#type': 'select',
    '#title': 'If any defect identified Treated/ Referred to Higher Facility?',
    '#webform_key': 'ifDefectIdentified',
    '#options': [],
    '#required': true,
    '#isDisabled': true
  },
  methodOfTreatment: {
    '#type': 'select',
    '#title': 'If treatment done, method of treatment',
    '#webform_key': 'methodOfTreatment',
    '#options': [],
    '#required': true,
    '#isDisabled': true
  },
  breastFeeding: {
    '#type': 'select',
    '#title': 'Breast feeding started within one hour of delivery',
    '#webform_key': 'breastFeeding',
    '#options': [],
    '#required': true,
  },
  isTestedForHIV: {
    '#type': 'select',
    '#title': 'Is the baby tested for HIV (open for mothers referred to ICTC)',
    '#webform_key': 'isTestedForHIV',
    '#options': [],
    '#required': false,
  },
  syphilisTest: {
    '#type': 'select',
    '#title': 'Syphilis Test',
    '#webform_key': 'syphilisTest',
    '#options': [],
    '#required': false
  },
  referredToNacpReferralFacility: {
    '#type': 'select',
    '#title': 'Referred to NACP referral facility',
    '#webform_key': 'referredToNacpReferralFacility',
    '#options': [],
    '#required': false,
    '#isDisabled': true,
  },
  isNevirapineSyrupStarted: {
    '#type': 'select',
    '#title': 'Is Nevirapine syrup started at birth (open for mothers referred to ICTC)',
    '#webform_key': 'isNevirapineSyrupStarted',
    '#options': [],
    '#required': false,
    '#isDisabled': false
  },
  vitaminKGiven:{
    '#type': 'date',
    '#title': 'Date of Vitamin K Vaccination',
    '#webform_key': 'vitaminKGiven',
    '#required': false,
    '#serviceId': '',
    '#isDisabled': false
  },
  hbigVaccination: {
    '#type': 'date',
    '#title': 'Date of HBIG Vaccination',
    '#webform_key': 'hbigVaccination',
    '#required': false,
    '#serviceId': '',
    '#isDisabled': false
  },
  whetherAefiReported: {
    '#type': 'select',
    '#title': 'Whether AEFI reported?',
    '#webform_key': 'whetherAefiReported',
    '#options': [],
    '#required': true
  },
};

export const DeathDetailsData:any = {
  deathHappenedDueTo: {
    '#type': 'select',
    '#title': 'Death happened due to',
    '#webform_key': 'deathHappenedDueTo',
    '#required': true,
    '#options': []
  },
  dateOfDeath: {
    '#type': 'date',
    '#title': 'Date of Death',
    '#webform_key': 'dateOfDeath',
    '#required': true,
    '#maxDate': today,
  },
  timeOfDeath: {
    '#type': 'time',
    '#title': 'Time Of Death',
    '#webform_key': 'timeOfDeath',
    '#required': true,
    '#isCurrentTime': true,
    '#isDisabled': true
  },
  probableCauseOfDeath: {
    '#type': 'select',
    '#title': 'Probable Cause of Death',
    '#webform_key': 'probableCauseOfDeath',
    '#required': true,
    '#options': [],
    '#isDisabled': true
  },
  placeOfDeath: {
    '#type': 'select',
    '#title': 'Place Of Death',
    '#webform_key': 'placeOfDeath',
    '#required': true,
    '#options': [],
  },
  notificationSetByAsha: {
    '#type': 'select',
    '#title': 'Notification sent by ASHA within 24 Hrs',
    '#webform_key': 'notificationSetByAsha',
    '#required': true,
    '#options': options,
  },
  FBIRCompletedByANM: {
    '#type': 'select',
    '#title': 'FBIR Completed by ANM/ MPW?',
    '#webform_key': 'FBIRCompletedByANM',
    '#required': true,
    '#options': options,
  },
};

export const DeathDetailsDataView:any = {
  death_reason_name: {
    'title': 'Death reason',
    'webform_key': 'death_reason_name',
    'value': ''
  },
  date_of_death: {
    'title': 'Date of Death',
    'webform_key': 'date_of_death',
    'value': ''
  },
  timeOfDeath: {
    'title': 'Time Of Death',
    'webform_key': 'timeOfDeath',
    'value': ''
  },
  probable_cause_of_death_name: {
    'title': 'Probable Cause of Death',
    'webform_key': 'probable_cause_of_death_name',
    'value': ''
  },
  place_of_death_name: {
    'title': 'Place Of Death',
    'webform_key': 'place_of_death_name',
    'value': ''
  },
  death_notification_sent_by_asha_with_24hrs: {
    'title': 'Notification sent by ASHA within 24 Hrs',
    'webform_key': 'death_notification_sent_by_asha_with_24hrs',
    'value': ''
  },
  fbir_completed_by_anm: {
    'title': 'FBIR Completed by ANM/ MPW?',
    'webform_key': 'fbir_completed_by_anm',
    'value': ''
  },
};

export const NewBornDetailsState = {
  babyCried: {
    isError: false,
    message: '',
    isDisable: false,
    value: '',

  },
  referred: {
    isError: false,
    message: '',
    isDisable: false,
    value: '',

  },
  isChildAdmitted: {
    isError: false,
    message: '',
    isDisable: false,
    value: '',

  },
  birthDefectSeen: {
    isError: false,
    message: '',
    isDisable: true,
    value: '',

  },
  ifDefectIdentified: {
    isError: false,
    message: '',
    isDisable: true,
    value: '',

  },
  methodOfTreatment: {
    isError: false,
    message: '',
    isDisable: true,
    value: '',

  },
  breastFeeding: {
    isError: false,
    message: '',
    isDisable: true,
    value: '',

  },

  isTestedForHIV: {
    isError: false,
    message: '',
    isDisable: true,
    value: '',

  },
  isNevirapineSyrupStarted: {
    isError: false,
    message: '',
    isDisable: true,
    value: '',

  },
  hbigVaccination: {
    isError: false,
    message: '',
    isDisable: false,
    value: '',

  },
  vitaminKGiven: {
    isError:false,
    message:'',
    isDisable:false,
    value:'',
  },
  whetherAefiReported: {
    isError: false,
    message: '',
    isDisable: true,
    value: '',

  },
 
  syphilisTest:{
    isError: false,
    message: '',
    isDisable: true,
    value: '',
  },
  referredToNacpReferralFacility:{
    isError: false,
    message: '',
    isDisable: true,
    value: '',
  }
}

export const DeathDetailsState = {
  deathHappenedDueTo: {
    isError: false,
    message: '',
    isDisable: false,
    value: '',
  },
  dateOfDeath: {
    isError: false,
    message: '',
    isDisable: false,
    value: '',
  },
  timeOfDeath: {
    isError: false,
    message: '',
    isDisable: true,
    value: '',
  },
  probableCauseOfDeath: {
    isError: false,
    message: '',
    isDisable: true,
    value: '',
  },
  placeOfDeath: {
    isError: false,
    message: '',
    isDisable: true,
    value: '',
  },
  notificationSetByAsha: {
    isError: false,
    message: '',
    isDisable: true,
    value: '',
  },
  FBIRCompletedByANM: {
    isError: false,
    message: '',
    isDisable: true,
    value: '',
  }
}
export const ServiceReportCodeForChild = {
  babyCriedImmediatelyAtBirth: 'baby_cried_immediately_at_birth',
  referredForFurtherManagement: 'referred_for_further_management',
  isChildAdmittedInNbsuSncuNicu: 'is_child_admitted_in_nbsu_sncu_nicu',
  anyVisibleBirthDefectSeen: 'any_visible_birth_defect_seen',
  treatedOrReferred: 'if_any_defect_identified_above_treated_referred_to_higher_facility',
  methodOfTreatment: 'if_treatment_done_method_of_treatment',
  breastFeeding: 'breast_feeding_started_within_one_hour_of_delivery',
  syphilisCurativeCareGiven: 'syphilis_test',
  isNevirapineSyrupStartedAtBirth: 'is_nevirapine_syrup_started_at_birth',
  hivPositive: 'hiv_screening_test',
  aefiReported: 'whether_aefi_reported',
  deathFollowingAefi: 'death_following_aefi',
  diarrheaTreatment: 'diarrhea_treatment',
  havingPneumonia: 'is_the_child_having_pneumonia_fever_and_fast_breathing_chest-_in_drawing',
  probableCauseOfDeath: 'probable_causes_of_death',
  childProbableCauseOfDeath: 'child_probable_cause_of_death',
  hbig: 'hbig',
  opv0: 'opv0',
  bcg: 'bcg',
  hepb0: 'hep_b-0',
  vitK: 'vit-k',
  isDeathHappenedOtherThanAefi: 'is_death_happened_other_than_aefi',
  dateOfDeathFollowingAEFI: 'date_of_death_following_aefi',
  deathDueToOtherReason: 'death_due_to_other_reason',
  dateOfDeath: 'date_of_death',
  timeOfDeath: 'time_of_death',
  placeOfDeath: 'place_of_death',
  notificationSetByAsha: 'notification_set_by_asha',
  FBIRCompletedByANM: 'fbir_completed_by_anm',
  referredToNACP:'referred_to_nacp_referral_facility'
}

export const messages = {
  emptyFieldErrorMessage: 'This field cannot be kept blank. Select a valid value.',
  validDateErrorMessage: 'This field cannot be kept blank. Select a valid Date',
  validTimeErrorMessage: 'This field cannot be kept blank. Select a valid Time',
  validOptionsErrorMessage: 'This field cannot be kept blank. Select a valid option',
  visibleBirthDefectErrorMessage: 'Visible Birth defects cannot be kept empty. Select an applicable option. ',
  treatmentMethodErrorMessage: 'Treatment Method for Birth Defect cannot be kept blank. Select a valid option.',
  probableCauseOfdeathErrorMessage: 'Probable cause of Death cannot be kept blank. Select a valid option.',
  notificationSetByAshaErrorMessage: 'Notification field cannot be kept empty. Select a valid option. ',
  FBIRCompltedByANMErrorMessage: 'FBIR cannot be empty. Select a valid option.',
  placeOfdeathErrorMessage: 'Place of death cannot be kept blank. Select an applicable option.',
  newBornSuccessMessage: 'New Born details submitted successfully',
  newBornEditSuccessMessage: 'New Born details edited successfully',
  successMessage: 'Form submitted successfully'
}

export const COMMON_CONSTANTS = {
  NEW_BORN_DETAILS: 'New Born Details',
  DEATH_DETAILS: 'Death Details',
  FACILITY_DETAILS: 'Facility Details',
  HEADER_NAME:'New Born Care',
  DATE_OF_DEATH: 'date_of_death',
  TIME_OF_DEATH: 'timeOfDeath',
  BOOLEAN: 'boolean',
  DEATH_DUE_TO_AEFI:'Death due to AEFI',
  DEATH_DUE_TO_OTHER_THAN_AEFI:'Death due to other than AEFI',
  NOT_DONE: 'Not Done',
  HIV_SCREENING: 'hiv_screening_test',
  REFERRED_TO_CONFIRMATORY: 'referred_to_confirmatory_facility',
  HBSAG_TEST: 'hbsag_test',
  REACTIVE: 'reactive',
  NO_AEFI:'No AEFI',
  MODAL_TITLE: 'You have unsaved changes. Are you sure you want to leave without saving?'
}

export const FIELD_CONSTANTS = {
  BABY_CRIED : 'babyCried',
  IF_DEFECT_IDENTIFIED:'ifDefectIdentified',
  BIRTH_DEFECT_SEEN: 'birthDefectSeen',
  DEATH_RELATED_INFORMATION: 'deathRelatedInformation',
  DEATH_HAPPENED_DUE_TO: 'deathHappenedDueTo',
  DATE_OF_DEATH: 'dateOfDeath',
  SYPHILIS_TEST: 'syphilisTest',
  IS_TESTED_FOR_HIV: 'isTestedForHIV',
  IS_REFERRED:'referred',
  IS_AEFI_REPORTED:'whetherAefiReported'
}

export const BREAD_SCRUMB_CONSTANTS = {
  SERVICE_PROVIDER :'Service Provider',
  BENEFICIARY_PROFILE: 'Beneficiary Profile'
}

export const STATUS_CONSTANTS = {
  NO_DEFECT :'No defect',
  TREATED:'treated'
}

export const SYPHILIS_TEST_OPTIONS = {
  NOT_DONE: 'Not Done',
  REACTIVE: 'Reactive',
  NON_REACTIVE: 'Non Reactive'
}

export const IS_TESTED_FOR_HIV_OPTIONS = {
  REFERRED_TO_CONFIRMATORY_FACILITY: 'Referred to Confirmatory Facility',
  NOT_DONE: 'Not Done',
  NON_REACTIVE: 'Non-Reactive'
}